export const i = {
  year: (new Date()).getFullYear(),
  social: {
    fb: {
      name: 'Facebook',
      url: 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.qcalc.app',
    },
    twitter: {
      name: 'Twitter',
      url: 'https://twitter.com/home?status=https%3A//www.qcalc.app',
    },
    google: {
      name: 'Google+',
      url: 'https://plus.google.com/share?url=https%3A//www.qcalc.app',
    }
  },
  by: 'TrendCycle',
  url: 'https://mjunaidi.github.io',
  name: 'qCalculator',
  lead: 'iOS apps',
  tagline: 'Calculations made easy!',
  description: 'iOS apps to simplify the way to calculate anything.',
  products: [
    {
      name: 'Math qCalculator',
      description: 'Calculations made easy!',
      icon: './img/math-qcalc-icon.jpg',
      url:'https://itunes.apple.com/us/app/math-qcalculator/id1435296651',
    },
    {
      name: 'Matrix qCalculator',
      description: 'Matrix made easy!',
      icon: './img/matrix-qcalc-icon.jpg',
      url:'https://itunes.apple.com/us/app/matrix-qcalculator/id1434505248',
    },
  ],
  images: {
    sampleSm: './img/sample-sm.gif',
    sampleMd: './img/sample-md.gif',
    sampleLg: './img/sample-lg.gif',
    sampleQuick: './img/sample-quick.gif',
    sampleFix: './img/sample-fix.gif',
    sampleMatrixBig: './img/sample-matrix-big.gif',
    sampleMatrixSm: './img/sample-matrix-sm.gif',
  },
  features: [
    {
      name: 'View equation fully',
      description: 'View all inserted term values and each of thier operators fully.',
    },
    {
      name: 'Edit term easily',
      description: 'Inserted term values are editable and made equation easier to be updated if required.',
    },
    {
      name: 'Undo/Redo',
      description: 'Any mistake? Simply undo it. Or redo it if not',
    },
    {
      name: 'Always calculated',
      description: 'Answer of the equation is always display. Calculating on-the-go.',
    },
    {
      name: 'Extra features',
      description: 'Help you to solve more than simple equation. Available features now: Matrix (Available as In-App Purchases, or Standalone App). Upcoming: Graphs, Logarithm, Fractions, and more.',
      img: './img/sample-matrix-sm.gif',
    },
  ]
}



// WEBPACK FOOTER //
// ./src/i.js